import { QRCode } from "react-qrcode-logo";

import { useUser } from '../contexts/UserContext';

const LeadQR = () => {
  const { user } = useUser();

  const getLink = () => {
    const origin = window.location.origin;
    console.log(origin); // e.g., "https://example.com" or "http://localhost:3000"

    return `${origin}/leads/${user?.id}`
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <QRCode value={getLink()} size={200} />
    </div>
  );
};

export default LeadQR;